(() => {
  const destinationFor = (value) => {
    if (!value) return null;
    if (/tellescope/i.test(value)) return /better-sex/i.test(value) ? '/pages/sexual-health' : '/pages/get-started-weight-loss';
    try {
      const url = new URL(value, location.origin);
      const ownStore = url.origin === location.origin || /^(www\.)?wellmedr\.com$|^wellmedr\.myshopify\.com$/.test(url.hostname) || url.hostname.endsWith('.shopifypreview.com');
      if (ownStore && /\/products\//i.test(url.pathname)) return '/pages/get-started';
      // Keep store navigation in the current draft when opened through a shared preview host.
      if (ownStore && /^(https?:)?\/\//i.test(value) && (url.pathname === '/' || /^\/pages\//i.test(url.pathname))) return url.pathname + url.search + url.hash;
    } catch (_) { /* Ignore non-URL controls. */ }
    return null;
  };
  const update = (root) => {
    if (!(root instanceof Element) && root !== document) return;
    const links = [...root.querySelectorAll('[href],[data-href]')];
    if (root instanceof Element && root.matches('[href],[data-href]')) links.unshift(root);
    links.forEach((link) => {
      ['href', 'data-href'].forEach((attribute) => {
        const current = link.getAttribute(attribute);
        const target = destinationFor(current);
        if (target && current !== target) link.setAttribute(attribute, target);
      });
    });
  };
  update(document);
  new MutationObserver((records) => records.forEach((record) => {
    if (record.type === 'attributes') update(record.target);
    else record.addedNodes.forEach(update);
  })).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href', 'data-href'] });
})();
